import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CrisisAlertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crisis_alert"}/>
}
